/* eslint-disable complexity */
/* eslint-disable max-statements */

import CustomError from './custom-error';

export default function checkRoutingParams(snippet) {

    const { routingtype, routingmode, routingurl, metarouterurl } = snippet;

    const routingOrder = [];

    if (!routingtype) {
        throw new CustomError('No routing on this map');
    }

    if (
        !['google', 'deutsche-bahn', 'osrm', 'otp', 'cityway', 'idfm'].includes(
            routingtype
        )
    ) {
        throw new CustomError(`Unknown routingtype "${routingtype}"`);
    }

    if (!['driving', 'walking', 'bike', 'bus', 'multi'].includes(routingmode)) {
        throw new CustomError(`Unknown routingmode "${routingmode}"`);
    }

    if (typeof metarouterurl !== 'undefined') {
        // multi-routers.* is the permanent alias of routing.*: snippets carrying it stay valid.
        if (![
            'https://routing.getwemap.com',
            'https://routing.maaap.it',
            'https://multi-routers.getwemap.com',
            'https://multi-routers.maaap.it'
        ].includes(metarouterurl)) {
            throw new CustomError('metarouterurl is wrong, you must use: https://routing.getwemap.com (prod), https://routing.maaap.it (dev)');
        }
        const isDevServer = metarouterurl.endsWith('.maaap.it');
        routingOrder.push({
            name: 'Wemap Meta Router' + (isDevServer ? ' (dev server)' : ''),
            external: false,
            mode: 'walking',
            coverage: 'custom networks'
        });
    }

    if (routingtype === 'google') {
        routingOrder.push({
            name: 'Google',
            external: true,
            mode: 'unknown',
            coverage: 'world'
        });
        return routingOrder;
    }

    if (routingtype === 'deutsche-bahn') {
        if (routingurl !== 'https://deutsche-bahn-routing.getwemap.com') {
            throw new CustomError('routingurl for deutsche-bahn is wrong');
        }
        if (routingmode !== 'walking') {
            throw new CustomError('deutsche-bahn router works in walking mode only');
        }
        if (metarouterurl) {
            throw new CustomError('do not use deutsche-bahn router with metarouterurl '
                + 'because they overlap each others');
        }
        routingOrder.push({
            name: 'Deutsche-bahn',
            external: false,
            mode: 'walking',
            coverage: 'Berlin Hauptbahnof'
        });
        return routingOrder;
    }

    const osrmWalkingRouter = {
        name: 'OSRM',
        external: false,
        mode: 'walking',
        coverage: 'France and Taganrog outdoor'
    };
    const osrmDrivingRouter = {
        name: 'OSRM',
        external: false,
        mode: 'driving',
        coverage: 'France outdoor'
    };

    if (routingtype === 'osrm') {
        if (!['walking', 'driving'].includes(routingmode)) {
            throw new CustomError('routingmode for OSRM can only be \'walking\' or \'driving\'');
        }

        if (routingmode === 'walking') {
            if (routingurl) {
                if (routingurl !== 'https://routing-osrm.getwemap.com') {
                    throw new CustomError('routing url for osrm in walking mode must be https://routing-osrm.getwemap.com');
                }
                routingOrder.push(osrmWalkingRouter);
            }
            // This is the case when routing with metarouter only
            return routingOrder;
        }

        if (routingmode === 'driving') {
            if (routingurl !== 'https://routing-car.getwemap.com') {
                throw new CustomError('routing url for osrm in driving mode must be https://routing-car.getwemap.com');
            }
            routingOrder.push(osrmDrivingRouter);
            return routingOrder;
        }
    }

    const fallbackRouter = routingmode === 'driving' ? osrmDrivingRouter : osrmWalkingRouter;

    if (routingtype === 'cityway') {
        if (
            routingurl
            === 'https://api.lia2.cityway.fr/journeyplanner/api/opt/PlanTrips/json?DepartureType=COORDINATES&ArrivalType=COORDINATES'
        ) {
            routingOrder.push({
                name: 'Cityway',
                external: false,
                mode: routingmode,
                coverage: 'Le Havre'
            });
            routingOrder.push(fallbackRouter);
            return routingOrder;
        }
        if (
            routingurl
            === 'https://api.grandest2.cityway.fr/journeyplanner/api/opt/PlanTrips/json?DepartureType=COORDINATES&ArrivalType=COORDINATES&UserId=WEBRGE'
        ) {
            routingOrder.push({
                name: 'Cityway',
                external: false,
                mode: routingmode,
                coverage: 'Grand Est'
            });
            routingOrder.push(fallbackRouter);
            return routingOrder;
        }
        throw new CustomError('routingurl for Cityway seems wrong');
    }

    if (routingtype === 'idfm') {
        if (
            routingurl
            !== 'https://idfm.getwemap.com/marketplace/navitia/coverage/fr-idf/journeys'
        ) {
            throw new CustomError('routingurl for IDFM must be https://idfm.getwemap.com/marketplace/navitia/coverage/fr-idf/journeys');
        }

        routingOrder.push({
            name: 'Ile de France Mobilité (IDFM)',
            external: false,
            mode: routingmode,
            coverage: 'Ile de France'
        });
        routingOrder.push(fallbackRouter);
        return routingOrder;
    }

    if (routingtype === 'otp') {
        if (
            routingurl
            === 'https://data.mobilites-m.fr/api/routers/default/plan?routerId=prod&showIntermediateStops=true&minTransferTime=60&transferPenalty=60&numItineraries=3&walkBoardCost=300&arriveBy=false&ui_date=&walkSpeed=1.1112&walkReluctance=5&locale=fr_FR'
        ) {
            routingOrder.push({
                name: 'OpenTripPlanner (OTP)',
                external: false,
                mode: routingmode,
                coverage: 'Grenoble Metropole'
            });
            routingOrder.push(fallbackRouter);
            return routingOrder;
        }
        throw new CustomError('routingurl for otp seems wrong');
    }

    throw new CustomError('Something went wrong parsing the snippet');
}
